import { useQuery } from "@apollo/react-hooks";

import unavailableEvent from "../graph-ql/unavailableEvent.graphql";

const useQueryUnavailableEvent = (id: string | null) =>
  useQuery(unavailableEvent, {
    variables: { id },
    skip: !id,
    fetchPolicy: "network-only",
  });

export default useQueryUnavailableEvent;
